import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Modal } from '../../../../modal';
import MainTitle from '../../../components/MainTitle/index';
import { ErrorIcon } from '../../../components/Icon/index';
import { getError } from '../../store/selectors';
import theme from '../../../../theme';

const ErrorModal = styled(Modal)`
  .Overlay {
    z-index: 200;
    background-color: ${theme.colors.dark};
  }
`;

const ErrorPage = ({error}) => ( // eslint-disable-line
  <>
    <ErrorModal isOpen={error !== null} isClosable={false}>
      <MainTitle>
        <ErrorIcon />
        {' '}
        {error && error.name}
      </MainTitle>
      <div>
        {error && error.message}
      </div>
    </ErrorModal>
  </>
);

const mapStateToProps = (state) => ({
  error: getError(state),
});

const mapDispatchToProps = {
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ErrorPage);
